var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#windows_svg__clip0_4882_8308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.674 28.248L1.53 26.225v-9.363l10.143.171v11.215zm18.793-13.597l-16.473.282V3.29L30.467 0v14.651zm-18.793.317l-10.143.173V5.78l10.143-2.025v11.213zM30.467 32l-16.473-3.287V17.07l16.473.28V32z",
    fill: "#00ADEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "windows_svg__clip0_4882_8308"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 0 32)",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgWindows;